let config = {
    buildNumber: "179",
    cachedAPI: "https://api-cache.monumentalsportsnetwork.com",
    apiBaseUrl:'https://api.monumentalsportsnetwork.com',
    apiKey:  "eDDgMPynXA8W2YeB5b0qe9KtnsuKP96W8aBWQCEF",//'eDDgMPynXA8W2YeB5b0qe9KtnsuKP96W8aBWQCEF'-Prod,'G7qQCC8pEh45AhicVZSCYXydLmSMqUo6nCLrY7fj'-Develop,'GcJBaiAK8Q4brxo5dMJS64DhsP0nPtXi5oy5RrIE'-UAT,'Ohpr1USLuO8peC3bTTdlO62jT2jNmc2R2Et6lRRM'-QA,
    analyticsBaseUrl:'https://analytics-api.monumentalsportsnetwork.com/user-beacon',
    sseBaseUrl: 'https://event.monumentalsportsnetwork.com',
    wssBaseUrl: 'wss://ws.monumentalsportsnetwork.com',
    appCMSBaseUrl: 'https://appcms.monumentalsportsnetwork.com',
    buildAssetsUrl: 'https://v-msnprod.monumentalsportsnetwork.com',
    filesProxy: {
        directPaths: [
          '/apple-app-site-association',
          '/.well-known/apple-app-site-association',
          '/.well-known/assetlinks.json',
          '/robots.txt',
          '/ads.txt',
          '/app-ads.txt',
          '/sitemap1.xml',
          '/sitemap2.xml',
          '/sitemap3.xml',
          '/sitemap4.xml',
          '/sitemap5.xml',
          '/sitemap6.xml',
          '/sitemap7.xml',
          '/sitemap8.xml',
          '/sitemap9.xml',
          '/sitemap10.xml',
          '/offline.html',
          '/serviceWorker.js',
          '/sw.js'
        ]
      },
    env:"PROD"
   }
   module.exports.config = config;